/**
 * Vuex Store
 *
 * @author Lemuel Raganas
 */
import Vue from "vue";
import Vuex from "vuex";
import * as lobj from "lodash/object";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    configuration: {},
    preloadedRepos: {}, // A list of names that were preloaded
    translations: {},
    lastUpdate: {},
    isPreloadDone: {},
    data: {},
    checksum: {},
    status: {},
    worldCupMatches: {},
    pointsTable: {},
  },
  mutations: {
    setLastUpdate(state, payload) {
      Vue.set(state.lastUpdate, payload.year, payload.data);
    },
    setTranslations(state, payload) {
      if (state.translations === undefined || state.translations === null) {
        return;
      }

      let translations = lobj.get(state.translations, payload.year, {});
      translations = lobj.merge(translations, payload.data);
      Vue.set(state.translations, payload.year, translations);
    },
    setIsPreloadDone(state, payload) {
      Vue.set(state.isPreloadDone, payload.year, payload.data);
    },
    setData(state, pl) {
      if (pl === undefined || pl === null) {
        return;
      }

      const value = lobj.get(pl, "value");
      let name = lobj.get(pl, "name");
      name = lobj.get(pl, "key", name);

      state.data[name] = value;
    },
    addPreloadedRepo(state, payload) {
      const repos = lobj.get(state.preloadedRepos, payload.year, []);

      if (repos.includes(payload)) {
        return;
      }

      repos.push(payload.data);
      Vue.set(state.preloadedRepos, payload.year, repos);
    },
    removePreloadedRepo(state, payload) {
      const repos = lobj.get(state.preloadedRepos, payload.year, []);

      if (repos.includes(payload)) {
        const index = repos.indexOf(payload);
        repos.splice(index, 1);
        Vue.set(state.preloadedRepos, payload.year, repos);
      }
    },
    clearPreloadedRepos(state, payload) {
      Vue.set(state.preloadedRepos, payload.year, []);
    },
    setChecksum(state, payload) {
      Vue.set(state.checksum, payload.year, payload.data);
    },
    setStatus(state, payload) {
      Vue.set(state.status, payload.year, payload.data);
    },
    setWorldCupMatches(state, payload) {
      Vue.set(state.worldCupMatches, payload.year, payload.data);
    },
    setPointsTable(state, payload) {
      Vue.set(state.pointsTable, payload.year, payload.data);
    },
  },
  actions: {
    setLastUpdate(context, payload) {
      context.commit("setLastUpdate", payload);
    },
    setTranslations(context, payload) {
      context.commit("setTranslations", payload);
    },
    setIsPreloadDone(context, payload) {
      context.commit("setIsPreloadDone", payload);
    },
    setData(context, pl) {
      context.commit("setData", pl);
    },
    addPreloadedRepo(context, payload) {
      context.commit("addPreloadedRepo", payload);
    },
    removePreloadedRepo(context, payload) {
      context.commit("removePreloadedRepo");
    },
    clearPreloadedRepos(context, payload) {
      context.commit("clearPreloadedRepos", payload);
    },
    setChecksum(context, payload) {
      context.commit("setChecksum", payload);
    },
    setStatus(context, payload) {
      context.commit("setStatus", payload);
    },
    setWorldCupMatches(context, payload) {
      context.commit("setWorldCupMatches", payload);
    },
    setPointsTable(context, payload) {
      context.commit("setPointsTable", payload);
    },
  },
});
